import type { TActivityLog } from '@conversed/shared/src/central/types/activity-log';
import { useTranslation } from 'react-i18next';

export interface MoreActivityStatsModalProps {
  moreInfo: TActivityLog['agent'];
  time: string;
  profilePic: string;
  triggeredBy: string;
}

export const MoreActivityStatsModal: React.FC<MoreActivityStatsModalProps> = ({
  time,
  moreInfo,
  profilePic,
  triggeredBy,
}) => {
  const { t } = useTranslation();

  return (
    <div className='tailwind-modal-body text-xs font-normal'>
      <span className='block text-secondary'>
        {t('activity-log.actions.triggered.by')}
        <span className='text-dark'>{triggeredBy} </span>
      </span>
      <span className='font-medium'>{time}</span>
      <div className='mt-2 pt-2 border-t'>
        {moreInfo ? (
          <div className='flex flex-row'>
            <img
              src={profilePic}
              alt='profile-pic'
              className='w-10 h-auto rounded-full mr-2'
            />

            <div className='flex flex-col'>
              <div className='font-medium'>
                {moreInfo?.firstName} {moreInfo?.lastName}{' '}
              </div>
              <div>
                <span>{moreInfo?.email}</span>
              </div>
            </div>
          </div>
        ) : (
          <div className='!text-primary-base'>
            {t('activity-log.actions.not.found.stats')}
          </div>
        )}
      </div>
    </div>
  );
};
